import React, { Component } from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import * as appsettings from './constants';
import './DailyView.css';

// Metric columns that support drill-down into URL failure telemetry.
const METRIC_ACCESSORS = ['availability', 'reliability', 'performance'];

// Computes the severity ('green' | 'orange' | 'red' | null) of a metric value,
// mirroring the cell coloring logic defined in constants.js columns.
function getMetricSeverity(accessor, value) {
    const v = Number(value);
    if (!v || v <= 0) {
        return null;
    }
    if (accessor === 'availability') {
        if (v >= appsettings.AvailabilityLegacyGreenTarget) return 'green';
        if (v >= appsettings.AvailabilityOrangeTarget) return 'orange';
        return 'red';
    }
    if (accessor === 'reliability') {
        if (v >= appsettings.ReliabilityGreenTarget) return 'green';
        if (v >= appsettings.ReliabilityOrangeTarget) return 'orange';
        return 'red';
    }
    if (accessor === 'performance') {
        if (v >= appsettings.PerformanceGreenTarget) return 'green';
        if (v >= appsettings.PerformanceOrangeTarget) return 'orange';
        return 'red';
    }
    return null;
}

export default class ReactDataTable extends Component {
    displayName = ReactDataTable.name;
    constructor(props) {
        super(props);
        this.state = { selected: '' }
    }
    render() {
        return (
            <div>
                <ReactTable
                    data={this.props.Metric}
                    columns={this.props.columns}
                    minRows={0}
                    maxRows={500}
                    defaultPageSize={100}
                    showPagination={true}
                    sortable={true}
                    filterable={true}
                    loading={this.props.loading}
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    style={{
                        borderStyle: 'solid',
                        borderWidth: "1px",
                        overflow: "hidden",
                    }}
                    className="-striped "
                    getTdProps={(state, rowInfo, column) => {
                        const accessor = column ? column.id || column.accessor : null;
                        const isMetric = accessor && METRIC_ACCESSORS.indexOf(accessor) !== -1;
                        let severity = null;
                        if (isMetric && rowInfo && rowInfo.row) {
                            severity = getMetricSeverity(accessor, rowInfo.row[accessor]);
                        }
                        const clickable = !!(isMetric && (severity === 'orange' || severity === 'red') && this.props.onMetricCellClick);
                        return {
                            title: clickable ? 'Click to view the URL failures causing this dip' : undefined,
                            style: {
                                borderColor: "#f7f7f7",
                                textAlign: 'center',
                                fontSize: '12px',
                                padding: '1px',
                                borderWidth: '0px',
                                wordWrap: 'break-word',
                                whiteSpace: 'pre-wrap',
                                cursor: clickable ? 'pointer' : 'default',
                                textDecoration: clickable ? 'underline' : 'none'
                            },
                            onClick: (e, handleOriginal) => {
                                if (clickable && rowInfo && rowInfo.original) {
                                    this.props.onMetricCellClick(rowInfo.original, accessor, severity);
                                }
                                if (handleOriginal) {
                                    handleOriginal();
                                }
                            }
                        };
                    }}

                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                            return {
                                onClick: (e) => {
                                    appsettings.SelectedRow[0].value = rowInfo.index;
                                    this.setState({
                                        selected: rowInfo.index
                                    })
                                },
                                style: {
                                    background: rowInfo.index === this.state.selected ? '#96B1C7' : ''

                                }
                            }
                        } else {
                            return {}
                        }
                    }
                    }


                    getTheadThProps={() => {
                        return {
                            style: {
                                background: "#f7f7f7",
                                borderColor: "#f7f7f7",
                                color: 'black',
                                textAlign: 'left',
                                fontSize: '14px',
                                height: '30px',
                                fontWeight: 'bold'
                            }
                        };
                    }}

                />

            </div>
        );
    }
}
